import AstroStaticPage from "@/common/components/AstroStaticPage";
import React from "react";
import { Data } from "./data";

const Numerology = () => {
  return <AstroStaticPage data={Data} />;
};

export default Numerology;
